import { buildSessionScopeKey } from '../api/auth';
import type { SiteType } from '../types/schema';
import { buildDraftScopeKey } from './useFormDraft';
import { useProgramConfig } from './useProgramConfig';

interface CanonicalProgramIdentityFields {
  clientName: string;
  programName: string;
}

export interface ResolvedProgram {
  clientName: string;
  programName: string;
  sessionScopeKey: string;
  draftScopeKeys: Record<SiteType, string>;
}

export function resolveProgramIdentity({ clientName, programName }: CanonicalProgramIdentityFields): ResolvedProgram {
  return {
    clientName,
    programName,
    sessionScopeKey: buildSessionScopeKey(clientName, programName),
    draftScopeKeys: {
      enrollments: buildDraftScopeKey('enrollments', clientName, programName),
      escalations: buildDraftScopeKey('escalations', clientName, programName),
    },
  };
}

export function useResolvedProgram() {
  const query = useProgramConfig();
  const resolvedProgram = query.data ? resolveProgramIdentity(query.data) : null;

  return {
    ...query,
    resolvedProgram,
    sessionScopeKey: resolvedProgram?.sessionScopeKey ?? null,
  };
}